import React, { useState, useEffect } from "react";
import { useDispatch } from 'react-redux';
import axios from "axios";
import { Spin } from "antd";

import { ScreensFormOne } from "../LeadForms/ScreensFormOne";
import { ScreensFormTwo } from "../LeadForms/ScreensFormTwo";
import ChatBot from "./ChatBot";

import { getSubdomain } from "~/helpers/getSubdomain";

import { Container, FormContainer, LoadingWrapper, ErrorTitle } from "../LeadForms/styles";

import { LOAD_SETTINGS } from '~/containers/Settings/actions';

export const ScreensPluginsForms = ({match}) => {
    const [isLoading, setIsLoading] = useState(true);
    const [formProps , setFormProps] = useState({});
    const [isCheckingIfFormIsValid, setIsCheckingIfFormIsValid] = useState(true);

    const token = match.params.token;
    const dispatch = useDispatch();

    async function fetchData() {
        try {
            const response = await axios.get(`${process.env.REACT_APP_API}/forms/token/${token}`, {
                headers: {
                  "X-Tenant": getSubdomain(),
                },
            });
            setFormProps(response.data);
            setIsLoading(false);
            dispatch({ type: LOAD_SETTINGS.SUCCESS, payload: { data: response.data.settings } });
        } catch (error) {
            console.log(error);
            setIsCheckingIfFormIsValid(false);
        }
    }

    useEffect(() => {
        fetchData();
    }, []);

    if(isLoading) {
        return (
            <Container>
                <FormContainer>
                {isCheckingIfFormIsValid ? (
                    <LoadingWrapper>
                    <Spin />
                    </LoadingWrapper>
                ) : (
                    <ErrorTitle>Não foi possível carregar o formulário.</ErrorTitle>
                )}
                </FormContainer>
            </Container>
        )
    }

    if(formProps.type === "form1") {
        return <ScreensFormOne formProps={formProps} />
    }
    

    if(formProps.type === "form2") {
        return <ScreensFormTwo formProps={formProps} />
    }

    if(formProps.type === "chatbot") {
        return <ChatBot 
            data={formProps} 
            isCheckingIfFormIsValid={isCheckingIfFormIsValid}
            token={token}
        />
    }
}

export default ScreensPluginsForms;